/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import React, { Fragment } from 'react';
import ActionButton from 'components/shared/Buttons/ActionButton';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

const SetExternalConsentError = ({
  errorMessage = <div>We are having technical difficulties.</div>,
  handleErrorClose
}) => (
  <div className="consent-error">
    {errorMessage}
    <button onClick={handleErrorClose} className="error-close">
      Ok
    </button>
  </div>
);

const NegativeButton = ({ id, negativeLabel, onClick }) => (
  <button id={id} onClick={onClick}>
    <span id="negative-consent">{negativeLabel}</span>
  </button>
);

const ActionButtonWithPermissions = WithUserPermissions(ActionButton);
const NegativeButtonWithPermissions = WithUserPermissions(NegativeButton);

export const ConsentModalContent = ({
  errorMessage,
  handleErrorClose,
  hasError,
  title,
  content,
  handleNegative,
  handlePositive,
  negativeLabel = 'Cancel',
  positiveLabel = 'I Agree'
}) => {
  return !hasError ? (
    <Fragment>
      <div className="consent-modal-content">
        <p className="consent-modal-title">{title}</p>
        <p
          className="consent-copy"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
      <div className="consent-disclosure">
        {handlePositive && (
          <ActionButtonWithPermissions
            id="positive-consent"
            type="primary"
            shouldDisable
            onClick={handlePositive}
          >
            {positiveLabel}
          </ActionButtonWithPermissions>
        )}
        {handleNegative && (
          <NegativeButtonWithPermissions
            id="cancel-consent-btn"
            negativeLabel={negativeLabel}
            onClick={handleNegative}
            shouldDisable
          ></NegativeButtonWithPermissions>
        )}
      </div>
    </Fragment>
  ) : (
    <SetExternalConsentError
      errorMessage={errorMessage}
      handleErrorClose={handleErrorClose}
    />
  );
};
